import { render, staticRenderFns } from "./query-card-verification.vue?vue&type=template&id=4435634d&scoped=true"
import script from "./query-card-verification.vue?vue&type=script&lang=js"
export * from "./query-card-verification.vue?vue&type=script&lang=js"
import style0 from "./query-card-verification.vue?vue&type=style&index=0&id=4435634d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4435634d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4435634d')) {
      api.createRecord('4435634d', component.options)
    } else {
      api.reload('4435634d', component.options)
    }
    module.hot.accept("./query-card-verification.vue?vue&type=template&id=4435634d&scoped=true", function () {
      api.rerender('4435634d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/customer-service/query-card-verification.vue"
export default component.exports